import { render, staticRenderFns } from "./auditProcess.vue?vue&type=template&id=2127e48c&scoped=true"
import script from "./auditProcess.vue?vue&type=script&lang=js"
export * from "./auditProcess.vue?vue&type=script&lang=js"
import style0 from "./auditProcess.vue?vue&type=style&index=0&id=2127e48c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2127e48c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2127e48c')) {
      api.createRecord('2127e48c', component.options)
    } else {
      api.reload('2127e48c', component.options)
    }
    module.hot.accept("./auditProcess.vue?vue&type=template&id=2127e48c&scoped=true", function () {
      api.rerender('2127e48c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/assessment/components/auditProcess.vue"
export default component.exports